import { ReactNode, useRef } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { alert } from '@flipster/ui/Alert';
import GoogleIcon from '@flipster/ui/assets/svgs/social/ic-google.svg';

import { authButtonCSSRaw } from '@web/app/[locale]/(web)/_auth/base-styles';

import { useGoogleSignInButton } from './use-google-sign-in-button';

interface Props {
  label?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  css?: Styles;
}

export const ContinueWithGoogle = ({ label, onClick, disabled, css: cssProps }: Props) => {
  const googleRef = useRef<HTMLDivElement | null>(null);
  const { ready, isInAppBrowser } = useGoogleSignInButton(googleRef);

  const onClickContinueWithGoogle = () => {
    onClick?.();

    if (!isInAppBrowser) return;
    alert.show({
      title: 'Error',
      message:
        'Please access flipster.io on a separate\nbrowser such as Google Chrome, to\naccess social sign-in or sign-up.',
      confirmText: 'Dismiss',
    });
  };

  return (
    <button
      type='button'
      onClick={onClickContinueWithGoogle}
      disabled={(!ready && !isInAppBrowser) || disabled}
      className={css(authButtonCSSRaw, cssProps)}
    >
      <GoogleIcon width={20} height={20} />
      {label}
      <div
        className={css({
          pos: 'absolute',
          top: 0,
          left: 0,
          w: '100%',
          minW: 0,
          transform: 'scaleY(1.5)',
          opacity: 0.0001,
        })}
        ref={googleRef}
      />
    </button>
  );
};
